<template>
  <div class="dz-stepper border-1 rounded-stepper small-stepper">
    <input :id="id" class="stepper" type="text" :value="modelValue">
  </div>
</template>

<script setup>

import {onMounted, ref} from "vue";

// eslint-disable-next-line no-unused-vars,no-undef
const props = defineProps({
  id: {
    type: String,
    default: "stepper"
  },
  modelValue: {

  }
})
// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue'])


const number = ref(1)
onMounted(() => {
  initStepper();
})

function initStepper(){
  // eslint-disable-next-line no-undef
  $("#" + props.id).TouchSpin({
    max: 100
  });

  // eslint-disable-next-line no-undef
  $("#" + props.id).on('change', () => {
    // eslint-disable-next-line no-undef
    number.value = $("#" + props.id).val()
    // eslint-disable-next-line no-undef
    emit('update:modelValue', parseInt($("#" + props.id).val()))

  })

}

</script>

<style scoped>
</style>